jQuery(document).ready(function ($) {


    /* Dixeno.de Link in Navi */

    $('.et-l--header').find('.et_pb_menu__logo-wrap').append($("<div class='dixeno-link'><a href='https://www.dixeno.de'>Zu DIXENO.de</div>"));

    if ($('body').hasClass('home')) {
        $('.dixeno-link').addClass('dx-main');

        $(window).scroll(function () {

            if ($('.et_builder_inner_content').hasClass('has_et_pb_sticky') === true) {
                $('.dixeno-link').addClass('sticky');
            } else {
                $('.dixeno-link').removeClass('sticky');
            }
        });

    } else {
        $('.dixeno-link').addClass('dx-sub');

        (window).scroll(function () {
            if ($('.et_builder_inner_content').hasClass('has_et_pb_sticky') === true) {
                $('.dixeno-link').addClass('sticky');
            } else {
                $('.dixeno-link').removeClass('sticky');
            }
        });
    }


    $(".et_pb_menu__logo").click(function () {
        var link = $('.et_pb_menu__logo a').attr('href');
        window.location.assign(link);
    });

    /* Breadcrumbs kürzen */
    if (window.matchMedia("(max-width: 767px)").matches) {
        $('.dipi-breadcrumbs.dipi-bc-left ul').each(function () {

            var ulliste = $(this);

            if (ulliste.find('li').length > 4) {
                $('.dipi-breadcrumb-home').next('.dipi-breadcrumb-separator').hide();
                $('.dipi-breadcrumb-home').hide();
            }
        });
    }


    /* Klassen für die DIXENO Benefits in den Stellenanzeigen */

    $('.dmach-acf-item-content li:contains("Interessante und schnell wachsende Kundenprojekte")').each(function () {
        $(this).addClass("kundenprojekte");
    });
    $('.dmach-acf-item-content li:contains("Einen unbefristeten Arbeitsvertrag mit einer fairen Bezahlung")').each(function () {
        $(this).addClass("arbeitsvertrag");
    });
    $('.dmach-acf-item-content li:contains("Einen modernen Arbeitsplatz")').each(function () {
        $(this).addClass("arbeitsplatz");
    });
    $('.dmach-acf-item-content li:contains("Übernahme der Studiengebühren und zusätzliches Gehalt")').each(function () {
        $(this).addClass("gebuehren");
    });
    $('.dmach-acf-item-content li:contains("Eine angenehme Arbeitsatmosphäre in einem tollen Team")').each(function () {
        $(this).addClass("angenehm");
    });
    $('.dmach-acf-item-content li:contains("Hunde sind willkommen")').each(function () {
        $(this).addClass("hund");
    });
    $('.dmach-acf-item-content li:contains("Frisches Obst & Getränke")').each(function () {
        $(this).addClass("obst");
    });
    $('.dmach-acf-item-content li:contains("Corporate Benefits (Mitarbeiter:innenrabatte)")').each(function () {
        $(this).addClass("benefits");
    });
    $('.dmach-acf-item-content li:contains("Flexible Arbeitszeiten & Homeoffice")').each(function () {
        $(this).addClass("arbeitszeiten");
    });
    $('.dmach-acf-item-content li:contains("Massage am Arbeitsplatz")').each(function () {
        $(this).addClass("massage");
    });
    $('.dmach-acf-item-content li:contains("Firmenevents & Mitarbeiter:innenaktivitäten")').each(function () {
        $(this).addClass("events");
    });
    $('.dmach-acf-item-content li:contains("Betriebliche Altersvorsorge")').each(function () {
        $(this).addClass("altersvorsorge");
    });
    $('.dmach-acf-item-content li:contains("Individuelle Weiterbildungsangebote")').each(function () {
        $(this).addClass("weiterbildung");
    });
    $('.dmach-acf-item-content li:contains("Zeit für Deine Abschlussarbeit")').each(function () {
        $(this).addClass("abschlussarbeit");
    });
    $('.dmach-acf-item-content li:contains("Frühe Verantwortung bei spannenden Kund:innenprojekten")').each(function () {
        $(this).addClass("verantwortung");
    });
    $('.dmach-acf-item-content li:contains("Individuelle Betreuung für Deine steile Lernkurve")').each(function () {
        $(this).addClass("lernkurve");
    });
    $('.dmach-acf-item-content li:contains("Übernahmechancen bei guten Leistungen")').each(function () {
        $(this).addClass("uebernahme");
    });


    /* Divi Klassen hinzufügen für die Spaltenanzahl */

    $('.et_pb_column_1_3').closest(".et_pb_row").addClass("et_pb_row_3col");
    $('.et_pb_column_1_4').closest(".et_pb_row").addClass("et_pb_row_4col");
    $('.et_pb_column_1_2').closest(".et_pb_row").addClass("et_pb_row_2col");

    /* Ende */

    /* Contact Form 7 Form abschicken auf Klick des Links */

    $(".wpcf7-submit").click(function () {
        $(this).closest(".wpcf7-form").submit();
    });

    /* Ende */


    jQuery('.owl-carousel-employee-picture-slider').owlCarousel({
        loop: false,
        dots: false,
        nav: true,
        navText: ["<i class='icons8-pfeil--lang--links'></i>","<i class='icons8-pfeil--lang--rechts'></i>"],
        items: 3,
        margin: 30,
        stagePadding: 30,
        responsiveClass:true,
        responsive:{
            0:{
                items:1,
                stagePadding: 20,
                margin: 20,
                dots: false,
                loop: true,
                nav: false
            },
            600:{
                items:2,
                dots: false,
                stagePadding: 30,
                margin: 30,
                loop: true,
                nav: false
            },

            1050:{
                items: 3,
                dots: false,
                stagePadding: 30,
                margin: 30,
                nav: true
            },
            1600:{
                items: 3,
                dots: false,
                stagePadding: 30,
                margin: 30,
            },
            1920:{
                items: 4,
                dots: false,
                stagePadding: 30,
                margin: 30
            }
        }
    });
});